import React, { useContext } from "react";
import { useSelector, useDispatch } from "react-redux";

import { CImage, CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from "@coreui/react";
import CIcon from "@coreui/icons-react";

import { AppSidebarNav } from "./AppSidebarNav";

import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";

// sidebar nav config
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import ls from "local-storage";
import { defaultSidebar, teamComponent } from "src/_nav";

const AppSidebar = () => {
  const [item, setItem] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  useEffect(() => {
    if (location.pathname !== "/voucher-usage-details") {
      ls.remove("stateVoucher");
    }
    if (location.pathname !== "/transaction-details") {
      ls.remove("state");
    }
  }, [location]);

  useEffect(() => {
    // if (JSON.parse(localStorage.getItem("userDetail"))?.org_id == 0) {
    //   setItem(defaultSidebar);
    // } else if (JSON.parse(localStorage.getItem("userDetail"))?.org_id != 0) {
    //   setItem(teamComponent);
    // }
    setItem(teamComponent);
  }, []);

  const unfoldableShow = useSelector((state) =>
    state.sidebarUnfoldable === undefined ? false : state.sidebarUnfoldable ? state.sidebarUnfoldable : false
  );
  const sidebarShow = useSelector((state) => state.sidebarShow);

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldableShow}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: "set", sidebarShow: sidebarShow });
        dispatch({ type: "set", sidebarUnfoldable: unfoldableShow });
      }}
      style={{ backgroundColor: "#306fba" }}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/">
        {/* <img
          className="sidebar-brand-full mb-2"
          alt="done"
          src={require('./logo.webp')}
          style={{ height: '35px', marginRight: '10px' }}
        /> */}
        <p className="sidebar-brand-full fs-4 mt-2 fw-semibold">
          <center>Move Juice Backoffice</center>
        </p>
        <img className="sidebar-brand-narrow" alt="done" src={require("./logo.webp")} style={{ height: "35px" }} />
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={item} />
        </SimpleBar>
      </CSidebarNav>
      <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => {
          const unfoldableState = unfoldableShow;
          dispatch({ type: "set", sidebarUnfoldable: !unfoldableState });
          dispatch({ type: "set", sidebarShow: unfoldableState ? sidebarShow : !sidebarShow });
        }}
      />
    </CSidebar>
  );
};

export default React.memo(AppSidebar);
